export function stringBytes(str) {
    let len = 0;
    for (var i = 0; i < str.length; i++) {
        let s = str.charCodeAt(i);
        while (s > 0) {
            len++;
            s = s >> 8;
        }
    }
    return len;
}
